import { OnllyofficeService } from "app/main/modules/operational/tools/document-model/document-editor/document-editor.service";
import { DocumentModel } from "./../../../../models/operational/tools/document-model/document-form";

import { Location } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { ApiGateway, PageOptions } from "cw-backend";
import { CwUtils } from "cw-utils";
import { BehaviorSubject, Observable } from "rxjs";
import { FilterTO } from "../../../../models/operational/filter/filterTO";

@Injectable()
export class DocumentModelListProvider implements Resolve<any> {
    documentModel: DocumentModel[];
    documentModelEdit: DocumentModel;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
        public onlyserver?: OnllyofficeService,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.documentModelEdit = this.state?.currentDocumentModel;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
            this.pageOptions.sortDirection = "asc";
            this.pageOptions.fieldSort = "title";
        } else {
            this.pageOptions = new PageOptions();
            this.pageOptions.sortDirection = "asc";
            this.pageOptions.fieldSort = "title";
        }

        return new Promise<void>((resolve, reject) => {
            resolve();
        });
    }

    get(id: number): Observable<DocumentModel> {
        if (!id) {
            return null;
        }
        return this.gw.get("document-model/:id", { id: id });
    }

    get currentDocumentModel(): DocumentModel {
        return this.documentModelEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("document-model/")
                .subscribe((res: HttpResponse<any>) => {
                    this.documentModel = res.body;
                    resolve(res);
                }, reject);
        });
    }

    getTypeAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("document-model/types/")
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    saveDocument(key: any) {
        this.onlyserver.onRequestSaveAs(key);

        /*
        var obj = {
          c: "forcesave",
          key: key,
          userdata: "saving"
        };
    
        this.gw.post2("coauthoring/CommandService.ashx", obj, {headers: {'access-control-allow-origin': '*'}}).subscribe({
          next: (res: HttpResponse<any>) => { },
        })
    */
    }

    getHeader(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("document-model/type/6")
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getFooter(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("document-model/type/7")
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getPage(filter: FilterTO): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post("document-model/search", filter)
                .subscribe((res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(
                            this.documentModel,
                            res.body.content,
                        ) &&
                        res.body.content.length > 0
                    ) {
                        this.documentModel = res.body.content;
                        this.onDataChanged.next(this.documentModel);
                    } else {
                        this.documentModel = res.body.content;
                    }
                    resolve(res);
                }, reject);
        });
    }

    getPageType2(pageOptions: PageOptions, type: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(
                    "document-model/search/type/:type",
                    { type: type },
                    pageOptions,
                )
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        if (
                            !CwUtils.compare(
                                this.documentModel,
                                res.body.content,
                            ) &&
                            res.body.content.length > 0
                        ) {
                            this.documentModel = res.body.content;
                            this.onDataChanged.next(this.documentModel);
                        } else {
                            this.documentModel = res.body.content;
                        }
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    getPageType(pageOptions: PageOptions, type: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(
                    "document-model/search/type/:type",
                    { type: type },
                    pageOptions,
                )
                .subscribe((res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(
                            this.documentModel,
                            res.body.content,
                        ) &&
                        res.body.content.length > 0
                    ) {
                        this.documentModel = res.body.content;
                        this.onDataChanged.next(this.documentModel);
                    } else {
                        this.documentModel = res.body.content;
                    }
                    resolve(res);
                }, reject);
        });
    }

    getPageTypeAndPerformerId(
        pageOptions: PageOptions,
        type: number,
        performerId: string,
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(
                    "document-model/search/type/:type/performer/:performerId",
                    { type: type, performerId: performerId },
                    pageOptions,
                )
                .subscribe((res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(
                            this.documentModel,
                            res.body.content,
                        ) &&
                        res.body.content.length > 0
                    ) {
                        this.documentModel = res.body.content;
                        this.onDataChanged.next(this.documentModel);
                    } else {
                        this.documentModel = res.body.content;
                    }
                    resolve(res);
                }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }

    generatePdf(request, documentModel): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(
                    `document-model/pdf/${documentModel}?receituario=${request.id
                    }&medico=${request.professional.performer.id}&paciente=${request.patient.id
                    }&sistema=${1}`,
                )
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                    error(error) {
                        console.error(error);
                        reject(error);
                    },
                });
        });
    }

    generatePdfBase64(request, documentModel): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(
                    `document-model/pdf/base64/${documentModel}?receituario=${request.id
                    }&medico=${request.professional.performer.id}&paciente=${request.patient.id
                    }&sistema=${1}`,
                )
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                    error(error) {
                        console.error(error);
                        reject(error);
                    },
                });
        });
    }

    generatePdfHistory(
        patientId,
        performerId,
        type,
        dateStart?: any,
        dateEnd?: any,
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(
                    `document-model/pdf/history?type=${type}&medico=${performerId}&paciente=${patientId}&dateStart=${dateStart}&dateEnd=${dateEnd}&sistema=${1}`,
                )
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                    error(error) {
                        console.error(error);
                    },
                });
        });
    }

    generatePdfList(request, documentModel): Promise<any> {
        return new Promise((resolve, reject) => {
            if (request.context == "document") {
                this.gw
                    .get(
                        `document/pdf/gcp/${request.id}?medico=${request.performer_id
                        }&paciente=${request.patient_id}&sistema=${1}`,
                    )
                    .subscribe({
                        next: (res: any) => {
                            resolve(res.body);
                        },
                        error: reject,
                    });
            } else {
                this.gw
                    .get(
                        `document-model/pdf/${documentModel}?receituario=${request.id
                        }&medico=${request.performer_id}&paciente=${request.patient_id
                        }&sistema=${1}`,
                    )
                    .subscribe({
                        next: (res: any) => {
                            resolve(res.body);
                        },
                        error: reject,
                    });
            }
        });
    }

    generatePdfListBase64(request, documentModel): Promise<any> {
        const path = request.context == "document"
            ? `document/pdf/${request.id}?medico=${request.performer_id}&paciente=${request.patient_id}&sistema=1`
            : `document-model/pdf/base64/${documentModel}?receituario=${request.id}&medico=${request.performer_id}&paciente=${request.patient_id}&sistema=1`;

        return new Promise((resolve, reject) => {
            this.gw.get(path).subscribe({
                next: (res: any) => resolve(res.body),
                error: reject,
            });
        });
    }

    signRequest(documentModel, request): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(
                    `document-model/signed/${documentModel}/${request.id}/${request.performer_id
                    }?receituario=${request.id}&medico=${request.performer_id
                    }&paciente=${request.patient_id}&sistema=${1}`,
                )
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                    error: reject,
                });
        });
    }

    checkPermissions(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("document/checkPermission").subscribe({
                next: (res: any) => {
                    resolve(res);
                },
                error(error) {
                    console.error(error);
                },
            });
        });
    }

    checkPermissionsInsert(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("document/checkPermissionInsert").subscribe({
                next: (res: any) => {
                    resolve(res);
                },
                error(error) {
                    console.error(error);
                },
            });
        });
    }
}
